/**
 * RecommendationsCard (P193) -- Home tile linking to the "so what?" inbox.
 * Shows the live critical/high counts so the prescription layer is visible
 * at a glance. Any authenticated user (it's the outcome surface for all
 * positions, not just exec).
 */
import { useTranslation } from "react-i18next";

import { MarsadIcon } from "shared/components/MarsadIcon";
import { BrassLink } from "shared/components/BrassLink";
import { Card, CardError } from "shared/components/Card";
import { useRecommendations } from "shared/recommendations/useRecommendations";

export function RecommendationsCard() {
  const { t } = useTranslation();
  const report = useRecommendations(50);

  if (report.isError) {
    return (
      <CardError
        testid="recommendations-card"
        message={t("recommendations.card.error")}
      />
    );
  }

  // A payload can arrive without the breakdown -- this crashed the
  // whole home when it did, taking every other card with it. Reading
  // one level deeper than you have checked is the shape of that bug.
  const crit = report.data?.by_severity?.critical ?? 0;
  const high = report.data?.by_severity?.high ?? 0;
  const total = report.data?.total ?? 0;

  return (
    <Card testid="recommendations-card" className="space-y-2">
      <p className="flex items-center gap-1.5 font-mono text-[10.5px] uppercase tracking-[0.16em] text-slate-400">
        <MarsadIcon name="recommendation" size={13} className="text-brand-brassDark" />
        {t("recommendations.card.heading")}
      </p>
      <p className="text-xs text-slate-600">
        {report.data
          ? t("recommendations.card.summary", { total, crit, high })
          : t("recommendations.card.body")}
      </p>
      <BrassLink
        to="/recommendations"
        testid="recommendations-card-open"
        className="inline-block"
      >
        {t("recommendations.card.open")}
      </BrassLink>
    </Card>
  );
}
